import { defineMessages } from 'react-intl';

export default defineMessages({
  comments: {
    id: 'sentinel.components.actionsForm.comments',
    defaultMessage: 'Comments (optional)',
  },
  department: {
    id: 'sentinel.components.actionsForm.department',
    defaultMessage: 'Department:',
  },
  submit: {
    id: 'sentinel.components.actionsForm.submit',
    defaultMessage: 'Submit',
  },
  noActions: {
    id: 'sentinel.components.actionsForm.noActions',
    defaultMessage: 'No actions are present for this transfer.',
  },
  allActionsApproved: {
    id: 'sentinel.components.actionsForm.allActionsApproved',
    defaultMessage: 'All assigned actions have been approved.',
  },
  noActionsResolvableByCurrentUser: {
    id: 'sentinel.components.actionsForm.noActionsResolvableByCurrentUser',
    defaultMessage: "Your user does not have access to resolve this transfer's actions.",
  },
});



// WEBPACK FOOTER //
// ./src/components/ActionsForm/messages.js